import React, { useEffect, useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import * as  R from 'ramda';
import LeadComponent from '../components/lead.component';
import { useAppDispatch } from '../../../../../../../../hooks/hooks';
import { selectLeadsQueryItems } from '../../../../../../../../redux/leads/selector';
import { selectShippingTypesListItems } from '../../../../../../../../redux/shippingTypes/selector';
import { leads } from '../../../../../../../../redux/leads/action';
import { shippingTypes } from '../../../../../../../../redux/shippingTypes/action';
import PageLoader from '../../../../../../../../components/PageLoader';


const CustomerLeadMobile = () => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const [isLoading, setIsLoading] = useState<boolean>(true)
  const leadQuery = useSelector(selectLeadsQueryItems)
  const shippingTypeListItems = useSelector(selectShippingTypesListItems)
  const [isQuery, setIsQuery] = useState<boolean>(false)
  const [
    leadDetails,
    setLeadDetails
  ] = useState<any>([])


  const fetchLeadById = () => {
    dispatch(leads.query({
      url: `https://logistics.digiit.${process.env.REACT_APP_API_URL}/api/v6.0/logistics/transport/leads/query`, entity: 'leads', jsonData: {

        Records: [
          {
            Context: {},
            Message: { Id: parmas?.id }
          }
        ]

      }
    })).then(() => {
      setIsQuery(true)
    }).then(() => {
      setIsLoading(false)
    })
  }

  const getCategoryName = (shippingTypeId: any) => {
    const ShippingTypeName = R.find(
      (shippingType: any) => parseInt(
        shippingType.Id,
        10
      ) === parseInt(
        shippingTypeId,
        10
      ),
      shippingTypeListItems?.result?.items
    )
    return ShippingTypeName ? ShippingTypeName.ShippingTypeName : ''
  }
  useEffect(
    () => {
      dispatch(shippingTypes.list({
        url: `https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/logistics/transport/shipping-types/list`, entity: 'shippingTypes', jsonData: {

        }
      })).then(() => {
        if (parmas?.id > 0) {
          fetchLeadById()
          setIsLoading(false)
        } else {
          setIsLoading(false)
        }
      })
    },
    []
  )
  useEffect(
    () => {

      if (isQuery) {
        setLeadDetails(leadQuery?.result?.items?.Message)
      }
    },
    [isQuery]
  )


  const back = () => {
    navigate('/customer/logistics/transport/leads')
  }

  return (
    <>
      {isLoading ? <PageLoader /> :

        <LeadComponent
          leadDetails={leadDetails}
          getCategoryName={getCategoryName}
          back={back}
        />}
    </>
  )

}

export default CustomerLeadMobile;